import React from 'react';
import Textfield from '@atlaskit/textfield';

import { InputWithHeaderAndDescriptionProperties as Properties } from './interfaces';
import {
    InputWithHeaderAndDescriptionWrapper as Wrapper,
    LevelConfigInputDescription as Description,
    LevelConfigInputHeader as Header,
} from './styles';

const InputWithHeaderAndDescription: React.FC<Properties> = ({
    value,
    header,
    description,
    onChange,
}) => (
    <Wrapper>
        <Header>{header}</Header>
        <Textfield
            onChange={(e: React.FormEvent) => onChange((e.target as HTMLInputElement).value)}
            value={value}
        />
        <Description>{description}</Description>
    </Wrapper>
);

export default InputWithHeaderAndDescription;
